import './App.scss';
import {LeftSide, RightSide} from "./components";
import './styles/fonts/AvertaStd-Regular.ttf';

function App() {
  return (
    <main className="main-app">

     <LeftSide />

     <RightSide />
    </main>
  );
}

export default App;
